import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';
import { getMerchantList, getMerchantDetail } from "../js/api/rbp";
import { logoutUser } from '../js/helper';
import { getSegmentInfo, getProductList } from "../js/api/rbp";

export const MerchantPage = () => {
  const navigate = useNavigate();
  const promoterDetails = JSON.parse(sessionStorage.getItem("userDetails"));

  const [selectedValue, setSelectedValue] = useState('');
  const [merchantName, setMerchantName] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handleDropdownChange = (event) => {
    const selectedMerchant = event.target.options[event.target.selectedIndex].dataset.merchantname;
    sessionStorage.setItem("merchantName", selectedMerchant);
    sessionStorage.setItem("merchantId", event.target.value);
    setSelectedValue(event.target.value);
    event.target.size = 1; event.target.blur();
  };

  useEffect(() => {
    setIsButtonDisabled(selectedValue === '');
  }, [selectedValue]);

  const handleNextButtonClick = async () => {
    setIsLoading(true);

    try {
      const responseData = await getMerchantInfo();
      sessionStorage.setItem("promoterDetails", JSON.stringify(responseData));
      navigate('/Add-items');
    } catch (error) {
      console.error('Error fetching merchant info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getMerchantInfo = async () => {
    try {
      const response = await getMerchantDetail(selectedValue);
      const responseData = response.data.data;
      await getProductList(selectedValue).then(async (response) => {
        await getSegmentInfo(selectedValue).then((response) => {
          let info = response.data.data;
          info.segmentCatageries.sort(function (a, b) {
            return a.displayOrder - b.displayOrder;
          });
          info.segmentInfo = info.segmentCatageries[0].segmentInfo;
          const silrepProduct = info.segmentCatageries.find(
            (category) => category.productName === process.env.REACT_APP_SIL_REP
          );
          responseData.isVipFlowEnabled = silrepProduct ? true : false;
          sessionStorage.setItem("RBPObject", JSON.stringify(info));
        }).catch((error) => { });
        sessionStorage.setItem("merchantStore", JSON.stringify(response.data.data));
      }).catch((error) => {
        //if status code is 401 then redirect to login page
        // when token is expired or invalid then redirect to login page
        if (error.response.status === 401) {
          logoutUser();
        }
      });
      responseData.downPayIntrest = responseData.downPayInterest == null || responseData.downPayInterest <= 0 ? 0.00 : responseData.downPayInterest;
      console.log(responseData);

      return responseData;
    } catch (err) {
      console.log('Promoter error details', err);
      throw err;
    }
  };

  useEffect(() => {
    setIsLoading(true);

    getMerchantList(promoterDetails.userId)
      .then(response => {
        console.log("Merchant ID res", response.data.data.merchants);
        if (response && response.data && response.data.data && response.data.data.merchants) {
          setMerchantName(response.data.data.merchants);
        } else {
          console.log("Invalid merchantListurl response format or missing data");
        }
      })
      .catch(error => {
        console.log("Exception:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
      {isLoading ? <Loader /> : ""}
      <div className="container-fluid">
        <h2>Merchant Store</h2>
        <div className="modal-body mb-3">
          <select className="form-control" value={selectedValue} onChange={handleDropdownChange} >
            <option value="">Select Merchant Name</option>
            {merchantName.map((merchant, index) => (
              <option key={index} value={merchant.merchantCode} data-merchantname={merchant.merchantName}>
                {merchant.merchantName}
              </option>
            ))}
          </select>
        </div>
        <div className="d-flex justify-content-center">
          <button className="btn btn-danger" onClick={handleNextButtonClick} disabled={isButtonDisabled}>Next</button>
        </div>
      </div>
    </div>
  );
};
